import { scheduleStatus } from 'app/core/interfaces/schedule';
import { EventColor } from 'calendar-utils';
import { encounterStatus } from '../interfaces/encounter';

export const cardColors: Record<string, EventColor> = {
    red: {
      primary: '#ad2121',
      secondary: '#FAE3E3',
    },
    blue: {
      primary: '#123e80',
      secondary: '#123e80',
    },
    yellow: {
      primary: '#e9820c',
      secondary: '#e9820c',
    },
  };
  
export const statusSchedule: scheduleStatus[] = [
    {
      id: 'planned',
      text: 'Pendente',
      color: 'red',
      icon: 'error'
    },
    {
      id: 'finished',
      text: 'Confirmado',
      color: 'grey',
      icon: 'check_circle'
    },
    {
      id: 'in-progress',
      text: 'Em atendimento',
      color: 'orange',
      icon: 'pending'
    },
  ]

  export const statusEncounter: encounterStatus[] = [
    {
      id: 'planned',
      text: 'Pendente',
      color: 'red',
      icon: 'error'
    },
    {
      id: 'finished',
      text: 'Confirmado',
      color: 'grey',
      icon: 'check_circle'
    },
    {
      id: 'in-progress',
      text: 'Em atendimento',
      color: 'orange',
      icon: 'pending'
    },
  ]